module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB4001-7c644e7f40ef63415b9dfe99066705b1.png";